export default __webpack_public_path__ + "static/media/angers.a85f3912.jpg";